import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import { LockOutlined } from "@ant-design/icons";

const Unauthorized = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f5f7fa",
      }}
    >
      <div
        style={{
          background: "#fff",
          padding: "40px",
          borderRadius: "12px",
          textAlign: "center",
          width: "420px",
          boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
        }}
      >
        <LockOutlined style={{ fontSize: 48, color: "#ff4d4f" }} />

        <h1 style={{ marginTop: 16, fontSize: 28 }}>403 – Access Denied</h1>

        <p style={{ color: "#6b7280", marginTop: 10 }}>
          You don’t have access to view this page.
        </p>

        <div style={{ marginTop: 30, display: "flex", gap: 10, justifyContent: "center" }}>
          <Button type="primary" danger ghost onClick={() => {
            localStorage.clear();
            sessionStorage.clear()
            window.location.reload()
            navigate("/login")
          }}>
            Logout
          </Button>
          <Button onClick={() => navigate(-1)}>
            Go Back
          </Button>

          <Button type="primary" onClick={() => navigate("/")}>
            Go to Dashboard
          </Button>

        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
